import '../styles/components/Highlight.css'
import {BgPenBrushesRed} from "./svg-icons/BgPenBrushesRed.tsx";

interface HighlightProps {
    text?: string
    cssClasses?: string
}

export function Highlight({
                              text = '',
                              cssClasses = ''
                          }: HighlightProps) {
    return (
        <span className="highlight is-highlight-item">
            <span className={`highlight-inner ${cssClasses ?? ''}`}>
                <span className="text">{text}</span>
                <span className="svg">
                    <BgPenBrushesRed/>
                </span>
            </span>
        </span>
    );
}
